import { render, staticRenderFns } from "./ProjectsTable.vue?vue&type=template&id=f3a5f2d6&scoped=true&"
import script from "./ProjectsTable.vue?vue&type=script&lang=js&"
export * from "./ProjectsTable.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsTable.vue?vue&type=style&index=0&id=f3a5f2d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a5f2d6",
  null
  
)

export default component.exports